module.exports = __webpack_public_path__ + "static/joc_02-f860b96bfc84479efc562030ea7c02b7.jpg";